import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useAuth } from "../context/authContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useAuth();
  const { user } = auth;
  // const currentUser = JSON.parse(localStorage.getItem("user"));
  const currentUser = true;

  return (
    <>
      <Route
        {...rest}
        render={(props) => {
          return user || currentUser ? (
            <Component {...props} />
          ) : (
            <Redirect to="/login" />
          );
        }}
      />
    </>
  );
};

export default PrivateRoute;
